// import ApolloClient, { InMemoryCache } from 'apollo-boost'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { split, ApolloLink } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { typeDefs } from './resolvers'
import { currentUser, currentMenuAuth } from './queries'
import { getMainDefinition } from 'apollo-utilities'
import { StateLoader } from '../apis/localStorage'

const SERVER_URI = `${process.env.REACT_APP_SERVER_URI}/graphql`
// const WEB_SOCKET_URI = `ws://${process.env.REACT_APP_SERVER_URI}/graphql`
// const SERVER_URI = process.env.NODE_ENV === 'development' ? '/graphql' : 'http://210.116.92.72:30004/graphql'

const cache = new InMemoryCache()

// create an http link:
const httpLink = createHttpLink({ uri: SERVER_URI })

// 모든 요청에 인증 토큰 첨부
const authLink = new ApolloLink((operation, forward) => {
	const token = StateLoader.loadToken()
	if (token) {
		operation.setContext(({ headers = {} }) => ({
			headers: { ...headers, authorization: `Bearer ${token}` },
		}))
	}
	return forward(operation)
})

// 인증 만료/실패 시 세션 삭제 후 로그인 화면으로 이동
// (토큰 도입 전 로그인한 세션도 포함, 동시 실패 시 알림은 한 번만)
const unauthenticatedLink = new ApolloLink((operation, forward) =>
	forward(operation).map(result => {
		const unauthenticated =
			result.errors && result.errors.some(err => err.extensions && err.extensions.code === 'UNAUTHENTICATED')
		const onLoginPage = window.location.hash === '' || window.location.hash === '#/'
		if (unauthenticated && !onLoginPage) {
			StateLoader.clear()
			alert('로그인이 만료되었습니다. 다시 로그인해주세요.')
			window.location.hash = '#/'
		}
		return result
	})
)

// create a websocket link:
// const wsLink = new WebSocketLink({
// 	uri: WEB_SOCKET_URI,
// 	options: {
// 		reconnect: true,
// 	},
// })

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
	// split based on operation type
	({ query }) => {
		const definition = getMainDefinition(query)
		// return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
		return definition.kind === 'OperationDefinition'
	},
	// wsLink,
	ApolloLink.from([authLink, unauthenticatedLink, httpLink])
)

const GraphQLClient = new ApolloClient({
	cache,
	link,
	// uri: SERVER_URI,
	clientState: {
		typeDefs,
	},
	resolvers: {}, // @client directive에 관한 경고 없애기 위함.
})

GraphQLClient.writeData({
	data: {
		isLoggedIn: false,
		loggedInUser: {
			id: '',
			groupCode: '',
			loginTime: '',
			p_code: null,
			p_name: null,
			__typename: 'loggedInUser',
		},
		groupWorks: [],
	},
})

export default GraphQLClient

export { currentUser, currentMenuAuth }

export const initMenuAuth = menuCode => ({
	menuCode,
	authRead: 1,
	authAdd: 1,
	authModify: 1,
	authDelete: 1,
})
